import React from "react"
import { useDashboardFilters } from "../state/dashboardFilters"
import ExerciseStats from "../components/ExerciseStats"

export default function ExercisesPage() {
  const { adminOnly } = useDashboardFilters()

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">Exercise Analytics</h1>
        <p className="text-muted-foreground">
          Explore which exercises are most used, replaced, and patterns in user behavior.
        </p>
      </div>

      <ExerciseStats adminOnly={adminOnly} />
    </div>
  )
}
